import React from "react";
import { NavLink } from "react-router-dom";
import logoImg from "../logo.svg";
import { Icon } from "react-icons-kit";
import { menu } from "react-icons-kit/feather/menu";
import { arrowLeft } from "react-icons-kit/feather/arrowLeft";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import { FaStar } from "react-icons/fa";
import axios from "axios";
import { useJwt } from "react-jwt";
import {
  CreateProductCategory,
  GetProductStatus,
} from "../apiconfig/authService";
import { toast } from "react-toastify";
import { RiLoaderFill } from "react-icons/ri";

function AddCategory(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem("accessToken"));
  if (isExpired) navigate("/");

  const setCategoryViewMessage = props.setMessage;

  const [categoryName, setCategoryName] = useState("");
  const [categoryImage, setCategoryImage] = useState(null);
  const [categoryStatusid, setCategoryStatusid] = useState(1);
  const [statusData, setStatusData] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleNameChange = (e) => {
    setCategoryName(e.target.value);
  };

  const handleStatusIdChange = (e) => {
    setCategoryStatusid(Number(e.target.value));
  };

  const handleImageChange = (e) => {
    setCategoryImage(e.target.files[0]);
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (!categoryName.trim()) {
        toast.error("Category Name is required!");
        return;
      }
      if (categoryImage === null) {
        toast.error("Category Image is required!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const formData = new FormData();
    formData.append("name", categoryName);
    formData.append("image", categoryImage);
    formData.append("statusid", categoryStatusid);
    try {
      setLoading(true);
      response = await CreateProductCategory(
        formData,
        localStorage.getItem("accessToken")
      );
      if (response.status === 201) {
        setLoading(false);
        setCategoryViewMessage("Category Added Successfully");
        toast.success(response?.data?.message);
        navigate("/category");
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error("An error occurred. Please try again later.");
        window.scrollTo(0, 0);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      try {
        const statusResponse = await GetProductStatus(
          localStorage.getItem("accessToken")
        );
        setStatusData(statusResponse.data);
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  return (
    <div className="dashboard-content">
      <Sidebar />
      {/* <div className="mobileOption d-flex align-items-center justify-content-between">
          <div  className="buyMore">
            <img className="img-fluid" src={logoImg} alt=""/>
          </div>
          <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
        </div> */}
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Add Category</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/category" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>

        <div
          role="tabpanel"
          className="personal-info tab-pane active storetab"
          id="pi"
        >
          {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
          <div className="row">
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <div className="d-flex">
                <label htmlFor="catName">Name</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="text"
                value={categoryName}
                onChange={handleNameChange}
                className="form-control  custom-input my-2"
                id="catName"
                placeholder="Product Name"
              />
              {/* </div> */}
            </div>
            <div className="form-group col-sm-12 col-lg-6 mb-3">
              {/* <div className="form-floating mb-4"> */}
              <div className="d-flex">
                <label htmlFor="catImg">Image</label>
                <FaStar size={7} className="text-danger" />
              </div>
              <input
                type="file"
                className="form-control custom-input my-2"
                onChange={handleImageChange}
                id="catImg"
                placeholder="Product Image"
              />
              {/* </div> */}
            </div>
          </div>
          {/* <div className="form-floating mb-4"> */}
          <div className="d-flex">
            <label htmlFor="floatingInput">Status</label>
            <FaStar size={7} className="text-danger" />
          </div>
          <select
            className="form-select custom-input my-2"
            onChange={handleStatusIdChange}
            value={categoryStatusid}
          >
            {statusData?.map((item, index) => (
              <option value={item.statusid} key={index}>
                {item.status}
              </option>
            ))}
          </select>
          {/* </div> */}
          <div className="row">
            <div className="col-12" style={{ height: "40px", width: "80px" }}>
              {loading ? (
                <div
                  className="btn btn-primary loader-active save-btn"
                  style={{ height: "100%", width: "100%" }}
                >
                  <RiLoaderFill
                    size={20}
                    className="spin-animation"
                    color="white"
                  />
                </div>
              ) : (
                <button
                  type="submit"
                  disabled={loading}
                  onClick={handleSubmitClick}
                  className="btn btn-primary save-btn text-uppercase"
                  style={{ height: "100%", width: "100%" }}
                >
                  Add
                </button>
              )}
            </div>
          </div>
        </div>
        <hr />
      </div>
    </div>
  );
}
export default AddCategory;
